/* Pretty Pixie quick size row (15 Oct 2026).
   Sizes sit on the card image. Tapping a size adds that variant to the cart and
   fires adhive:cart-updated, which the GoKwik cart drawer listens to. */
(() => {
  if (window.__ppQuickSize) return;
  window.__ppQuickSize = true;

  // Re-resolve the variant for a size in case the shopper changed colour on the card
  const resolve = (panel, btn) => {
    let variants = [];
    try { variants = JSON.parse(panel.dataset.variants || '[]'); } catch (e) { return btn.dataset.variantId; }
    const si = Number(panel.dataset.sizeIndex);
    const idInput = panel.closest('quick-add-component')?.querySelector('input[name="id"]');
    const current = variants.find((v) => String(v.id) === String(idInput?.value));
    if (!current) return btn.dataset.variantId;
    const match = variants.find((v) => v.o[si] === btn.dataset.size && v.o.every((x, i) => i === si || x === current.o[i]));
    if (!match || !match.a) return '';
    return String(match.id);
  };

  const updateBubble = async () => {
    try {
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      document.querySelectorAll('.cart-bubble__text-count').forEach((el) => { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'pp-quick-size', data: { source: 'pp-quick-size', itemCount: cart.item_count } }
      }));
    } catch (e) { /* bubble refresh is best-effort */ }
  };

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.pp-qs__size');
    if (!btn) return;
    // Keep the tap from opening the product page
    e.preventDefault();
    e.stopPropagation();

    const panel = btn.closest('.pp-qs');
    if (!panel || btn.disabled || panel.hasAttribute('data-busy')) return;

    const msg = panel.querySelector('.pp-qs__msg');
    if (msg) msg.textContent = '';
    const variantId = resolve(panel, btn);
    if (!variantId) {
      if (msg) msg.textContent = 'This size is sold out';
      return;
    }

    panel.setAttribute('data-busy', '');
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'Could not add this size');
      }
      btn.classList.add('is-added');
      await updateBubble();
      document.dispatchEvent(new CustomEvent('adhive:cart-updated', { bubbles: true }));
      setTimeout(() => btn.classList.remove('is-added'), 1200);
    } catch (err) {
      if (msg) msg.textContent = err.message;
    } finally {
      panel.removeAttribute('data-busy');
    }
  }, true);
})();
